import salaryService from 'ApiService/Accountant/salaryService';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import SalaryDetails from './SalaryDetails';
import { AuthContext } from 'contexts/AuthContext';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const SalaryModal = ({
  employee,
  onClose,
  onSalaryCreated,
  employeeType,
  handleCloseModal,
  selectedEmployee,
}) => {
  const [isSalaryCreationMode, setIsSalaryCreationMode] = useState(
    !employee?.salary
  );
  const [currentSalary, setCurrentSalary] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    accountNumber: '',
    ifscCode: '',
    bankName: '',
  });
  const [isModalOpenConfirmation, setIsModalOpenConfirmation] = useState(false);
  const { state } = useContext(AuthContext);
  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({ ...prev, [name]: value }));
  };

  const Confirmation = async () => {
    setIsModalOpenConfirmation(true);
  };

  const maskAccountNumber = (accountNumber) => {
    if (!accountNumber) return '';
    const visible = accountNumber.slice(-4);
    const masked = accountNumber.slice(0, -4).replace(/./g, 'X');
    return masked + visible;
  };

  const handleCreateSalary = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const selectedBranch = state?.selectedBranch || '';
    console.log(selectedBranch, 'selectedBranch');
    if (employee._id && employeeType && currentSalary && bankDetails) {
      try {
        const payload = {
          employeeId: employee._id,
          employeeType,
          currentSalary: parseFloat(currentSalary),
          bankDetails,
          selectedBranch,
        };
        const response = await salaryService.createEmployeeSalary(payload);

        if (response?.data?.success) {
          toast.success(response.data.message);
          onClose();
          onSalaryCreated();
          setIsModalOpenConfirmation(false);
        } else {
          toast.error('Failed to create salary');
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            'An error occurred while creating salary'
        );
      } finally {
        setIsSubmitting(false);
      }
    } else {
      toast.error('All fields are mandatory');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
      <div className="relative mx-auto my-6 w-auto max-w-3xl">
        <div className="relative flex w-full flex-col rounded-lg border-0 bg-white  shadow-lg outline-none focus:outline-none dark:bg-navy-800">
          <div className="flex items-start justify-between rounded-t border-b border-solid border-gray-300 p-5">
            {isSalaryCreationMode ? (
              <h3 className="text-2xl font-semibold dark:text-white">
                Create Salary for {selectedEmployee?.name}
              </h3>
            ) : (
              <>
                <h3 className="text-2xl font-semibold dark:text-white ">
                  View Salary for {selectedEmployee?.name}
                </h3>
              </>
            )}
            <button
              className="bg-transparent text-black float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none outline-none focus:outline-none"
              onClick={handleCloseModal}
            >
              <span className="bg-transparent text-black block h-6 w-6 text-2xl outline-none focus:outline-none dark:text-white">
                ×
              </span>
            </button>
          </div>
          {isSalaryCreationMode ? (
            <>
              <div className="relative flex-auto p-6">
                <input
                  type="number"
                  value={currentSalary}
                  onChange={(e) => setCurrentSalary(e.target.value)}
                  placeholder="Enter current salary"
                  className="focus:shadow-outline mb-4 w-full rounded-lg border px-3 py-2 text-base text-gray-700 placeholder-gray-600 dark:bg-navy-800"
                />
                <input
                  type="text"
                  name="accountNumber"
                  value={bankDetails.accountNumber}
                  onChange={handleBankDetailsChange}
                  placeholder="Enter account number"
                  className="focus:shadow-outline mb-4 w-full rounded-lg border px-3 py-2 text-base text-gray-700 placeholder-gray-600 dark:bg-navy-800"
                />
                <input
                  type="text"
                  name="ifscCode"
                  value={bankDetails.ifscCode}
                  onChange={handleBankDetailsChange}
                  placeholder="Enter IFSC code"
                  className="focus:shadow-outline mb-4 w-full rounded-lg border px-3 py-2 text-base text-gray-700 placeholder-gray-600 dark:bg-navy-800"
                />
                <input
                  type="text"
                  name="bankName"
                  value={bankDetails.bankName}
                  onChange={handleBankDetailsChange}
                  placeholder="Enter bank name"
                  className="focus:shadow-outline w-full rounded-lg border px-3 py-2 text-base text-gray-700 placeholder-gray-600 dark:bg-navy-800"
                />
              </div>
              <div className="flex items-center justify-end rounded-b border-t border-solid border-gray-300 p-6">
                <button
                  className="background-transparent mb-1 mr-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none focus:outline-none"
                  type="button"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  className="mb-1 mr-1 rounded bg-green-500 px-6 py-3 text-sm font-bold uppercase text-white shadow outline-none hover:shadow-lg focus:outline-none active:bg-green-600"
                  type="button"
                  onClick={Confirmation}
                >
                  {isSubmitting ? 'Creating...' : 'Yes, Create Salary'}
                </button>
              </div>
            </>
          ) : (
            <SalaryDetails
              employeeData={employee}
              onSalaryCreated={onSalaryCreated}
            />
          )}
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpenConfirmation}
        onClose={() => setIsModalOpenConfirmation(false)}
        onConfirm={handleCreateSalary}
        title="Confirm Salary Creation"
        message={
          <div className="space-y-3 text-left">
            <p className="text-lg font-semibold text-navy-700 dark:text-white">
              Please confirm the following salary details:
            </p>
            <div className="mt-3 grid grid-cols-2 gap-2 rounded-lg bg-gray-50 p-3 dark:bg-navy-900">
              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Employee:
              </span>
              <span className="text-sm text-navy-700 dark:text-white">
                {selectedEmployee?.name ||
                  employee?.name ||
                  'Selected Employee'}
              </span>

              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Employee Type:
              </span>
              <span className="text-sm capitalize text-navy-700 dark:text-white">
                {/* {employeeType || 'Not specified'} */}
                {employeeType === 'Account'
                  ? 'Accountant'
                  : employeeType === 'Placement'
                  ? 'Placement Officer'
                  : employeeType}
              </span>

              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Current Salary:
              </span>
              <span className="text-sm font-semibold text-green-600 dark:text-green-400">
                ₹{parseFloat(currentSalary).toLocaleString() || '0'}
              </span>

              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Bank Name:
              </span>
              <span className="text-sm text-navy-700 dark:text-white">
                {bankDetails.bankName || 'Not provided'}
              </span>

              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Account Number:
              </span>
              <span className="text-sm text-navy-700 dark:text-white">
                {maskAccountNumber(bankDetails.accountNumber) || 'Not provided'}
              </span>

              <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                IFSC Code:
              </span>
              <span className="text-sm text-navy-700 dark:text-white">
                {bankDetails.ifscCode || 'Not provided'}
              </span>
            </div>
            <p className="mt-2 text-sm text-red-500">
              Please verify all details before confirming. This will create a
              new salary record for the employee.
            </p>
          </div>
        }
        confirmText={isSubmitting ? 'Creating...' : 'Yes, Create Salary'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={isSubmitting}
      />
    </div>
  );
};

export default SalaryModal;
